module.exports = __webpack_public_path__ + "img/antes_despues_210.0e3f72f2.png";